

document.addEventListener("DOMContentLoaded", function () {
    const elements = document.querySelectorAll('.img-text-flavor-inside');
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio >= 0.2) {
                entry.target.classList.add('active');
            } else {
                entry.target.classList.remove('active');
            }
        });
    }, {
        threshold: [0, 0.2]
    });
    elements.forEach(el => observer.observe(el));
});

document.addEventListener("DOMContentLoaded", function () {
    const elements = document.querySelectorAll('.home_slider_bls');
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio >= 0.2) {
                entry.target.classList.add('active');
            } else {
                entry.target.classList.remove('active');
            }
        });
    }, {
        threshold: [0, 0.2]
    });
    elements.forEach(el => observer.observe(el));
});

document.addEventListener("DOMContentLoaded", function () {
    const elements = document.querySelectorAll('.about_us_bls');
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio >= 0.2) {
                entry.target.classList.add('active');
            } else {
                entry.target.classList.remove('active');
            }
        });
    }, {
        threshold: [0, 0.2]
    });
    elements.forEach(el => observer.observe(el));
});

document.addEventListener("DOMContentLoaded", () => {
    const paragraph = document.querySelector("h2.scroll_text_bls");
    if (!paragraph) return;
    const text = paragraph.textContent.split("");
    paragraph.textContent = ""; 

    text.forEach(char => {
        const span = document.createElement("span");
        span.textContent = char;
        paragraph.appendChild(span);
    });

    window.addEventListener("scroll", () => {
        const rect = paragraph.getBoundingClientRect();
        const triggerPoint = (rect.y - window.innerHeight / 1.5) * -1;

        paragraph.childNodes.forEach((letter, i) => {
            letter.style.color = i < triggerPoint ? "#fff3dc" : "rgb(156 162 163 / 25%)";
        });
    });
});
